import React from 'react';
import {NodeProps} from 'reactflow';

import {InvisibleNodeHandle} from 'ui-library/reactflow/handles/InvisibleNodeHandle';
import {NodeHandleProps} from 'ui-library/reactflow/nodes/BenchlingNode/BenchlingNodeTypes';
import BenchlingTitleNode from 'ui-library/reactflow/nodes/BenchlingTitleNode/BenchlingTitleNode';

interface EntityNodeData {
  entityId: string;
}

function EntityNodeHandle(props: NodeHandleProps): JSX.Element {
  if (props.handleType === 'target') {
    return <InvisibleNodeHandle nodeId={props.nodeId} handleType="target" />;
  }
  if (props.handleType === 'source') {
    return <InvisibleNodeHandle nodeId={props.nodeId} handleType="source" />;
  }
  return <></>;
}

/**
 * Renders a node within the entity map for the given entity.
 */
export default function EntityNode(props: NodeProps<EntityNodeData>): JSX.Element {
  const {entityId} = props.data;

  return (
    <BenchlingTitleNode
      {...props}
      id={entityId}
      data={{nodeName: entityId, nodeHeaderHandleRenderer: EntityNodeHandle}}
    />
  );
}
